import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import RankingSection from './components/RankingSection';
import LatestArticles from './components/LatestArticles';
import HomeFAQ from './components/HomeFAQ';

export default function Home() {
  useEffect(() => {
    document.title = '韩影精选 - 韩国伦理片高分推荐与深度解析';
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩影精选',
    url: 'https://korean-film-review.readdy.ai/',
    description: '精选韩国伦理片高分榜单，涵盖经典与最新韩国伦理电影推荐，深度解析剧情、演员与导演风格',
    inLanguage: 'zh-CN',
  };

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩影精选',
    url: 'https://korean-film-review.readdy.ai/',
    description: '韩国伦理电影深度解析与推荐平台',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <RankingSection />

        <section className="py-14 md:py-20 bg-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-6">
              以影视为镜，观照人性深渊
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              韩国伦理电影以其独特的艺术表达和深刻的社会批判，在世界影坛独树一帜。从朴赞郁的视觉奇观到李沧东的诗意写实，每一位导演都在用镜头探索人性的边界。我们致力于为影迷提供最专业、最深度的韩国伦理电影解析与推荐。
            </p>
          </div>
        </section>

        <LatestArticles />
        <HomeFAQ />
      </main>

      <Footer />
    </>
  );
}